import Loader from 'component/loader'
import React from 'react'

function ButtonGradient({
  type,
  disabled,
  label,
  processing,
  children,
  onClick,
  className,
}) {
  return (
    <button
      onClick={onClick}
      type={type || 'button'}
      className={`${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      } text-white ${className} bg-[#F5821F] hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-[#F5821F]/40 font-medium rounded-lg text-sm px-5 py-2.5 text-center transition-all duration-200`}
      disabled={disabled || processing}
    >
      {processing ? <Loader /> : label || children}
    </button>
  )
}

export default ButtonGradient